export default __webpack_public_path__ + "static/media/icon_greekFeet_right.122ecdeb.png";